const initialState = {
  fetching: false,
};

export default function tasksFetchingReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'TASKS_FETCHING':
      return { ...currentState, fetching: true };
    case 'TASKS_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    case 'FETCHING_SINGLE_DAY_TASK':
      return { ...currentState, fetching: true, day: action.day };
    case 'FETCHED_SINGLE_DAY_TASK':
      return { ...currentState, dayTasks: action.payload.data, fetching: false };
    case 'UPDATING_TASKS':
      return { ...currentState, fetching: true, day: action.day };
    case 'UPDATED_TASKS':
      return { ...currentState, dayTasks: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
